<template>
  <v-container>
    <v-row>
      <v-col
        ><h3>
          <b>{{ isGov ? "Projetos" : "Municípios" }} eixos</b>
        </h3></v-col
      >
    </v-row>

    <v-row>
      <v-col>
        <combobox-unidade-regional
          :filter="municipioEixo"
        ></combobox-unidade-regional>
      </v-col>
      <v-col>
        <municipio-combo
          :filter="municipioEixo"
          @allMunicipio="(e) => (allMunicipio = e)"
        ></municipio-combo>
      </v-col>
    </v-row>
    <v-row class="align-center">
      <v-col cols="auto">
        <app-axis-by-project-combobox
          :filter="municipioEixo"
          @change="changeEixo"
        >
        </app-axis-by-project-combobox>
      </v-col>
      <template v-if="municipioEixo.eixo && municipioEixo.eixo.length">
        <v-col cols="auto">
          <v-btn color="primary" @click="addEixo()">Adicionar Eixos</v-btn>
        </v-col>
      </template>
    </v-row>
    <template v-if="municipioEixo.eixo && municipioEixo.eixo.length">
      <v-row class="align-center">
        <v-col cols="auto">
          <strong
            >Já realiza ações do portfólio do eixo (local ou nacional)?</strong
          >
        </v-col>
        <v-col cols="auto">
          <v-radio-group v-model="eixoResposta" row @change="changeResposta">
            <v-radio label="Sim" :value="'Sim'"></v-radio>
            <v-radio label="Não" :value="'Não'"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="municipioEixo.eixo"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.amor="{ item }">
              {{ item.nome }}
            </template>
            <template v-slot:item.opcao="{ item }">
              <v-radio-group v-model="item.pergunta" row>
                <v-radio label="Sim" :value="'Sim'"></v-radio>
                <v-radio label="Não" :value="'Não'"></v-radio>
              </v-radio-group>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col> <h3>Municipios Selecionados</h3></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :items="municipioEixo.municipio"
          class="elevation-1 municipioEixoTable"
          :items-per-page="5"
          :footer-props="{ itemsPerPageText: 'Itens por página' }"
        >
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>
          <template v-slot:header="props">
            <thead>
              <tr>
                <th>{{ isGov ? "Projeto" : "Município" }}</th>
                <th colspan="50">
                  Já realiza ações do portfólio do eixo (local ou nacional)?
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.nome }}
              </td>
              <template v-if="allMunicipioEixo[item.municipioId]">
                <td
                  v-for="(municipioEixo, index) in allMunicipioEixo[
                    item.municipioId
                  ]"
                  :key="index"
                  :colspan="
                    index + 1 == allMunicipioEixo[item.municipioId].length
                      ? longestEixoMunicipio - index
                      : 1
                  "
                >
                  {{ municipioEixo.nomeEixo || municipioEixo.nome }}
                  <v-radio-group
                    v-model="municipioEixo.pergunta"
                    hide-details
                    @change="(e) => mudeiValor(e, municipioEixo)"
                  >
                    <v-radio label="Sim" :value="'Sim'"></v-radio>
                    <v-radio label="Não" :value="'Não'"></v-radio>
                  </v-radio-group>
                </td>
              </template>
              <template v-else>
                <td :colspan="longestEixoMunicipio">
                  Esse munícipio não possui nenhum eixo
                </td>
              </template>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="save()">Salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ComboboxUnidadeRegional from "@/modules/ur/components/Combobox.vue";
import { AppAxisByProjectCombobox } from "@/modules/axis";
import MunicipioCombo from "@/modules/user/components/MunicipioCombo.vue";
import { municipioEixoApi } from "@/modules/city/API/MunicipioEixo";
import { mapGetters, mapActions } from "vuex";
import AppYesOrNOCombobox from "@/modules/groups/components/Combobox";
import { compare } from "@/helpers/orderByAsc";
import Swal from "sweetalert2";

export default {
  components: {
    ComboboxUnidadeRegional,
    AppAxisByProjectCombobox,
    MunicipioCombo,
    AppYesOrNOCombobox,
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  data() {
    return {
      municipioEixo: { eixo: [], municipio: [] },
      longestEixoMunicipio: 0,
      allMunicipio: [],
      allMunicipioEixo: [],
      selectedMunicipioEixo: [],
      eixoResposta: null,
      municipioEixosDiferentes: {},
      headers: [
        {
          text: "Eixo",
          value: "amor",
        },
        { text: "Resposta", value: "opcao" },
      ],
    };
  },
  watch: {
    "municipioEixo.id_unidade_regional"(val) {
      if (val) {
        this.municipioEixo.municipio = this.allMunicipio.filter(
          (item) => item.id_unidade_regional == val
        );
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    changeEixo(e) {
      this.municipioEixo.eixo = e.map((item) => ({
        ...item,
        pergunta: item.pergunta ? item.pergunta : this.eixoResposta,
      }));
    },
    changeResposta(e) {
      this.municipioEixo.eixo = this.municipioEixo.eixo.map((item) => ({
        ...item,
        pergunta: e,
      }));
    },
    addEixo() {
      for (let i = 0; i < this.municipioEixo.municipio.length; i++) {
        const municipio = this.municipioEixo.municipio[i];
        const municipioEixo = this.allMunicipioEixo[municipio.municipioId];

        for (let j = 0; j < this.municipioEixo.eixo.length; j++) {
          const eixo = {
            ...this.municipioEixo.eixo[j],
            municipioId: municipio.municipioId,
            uf: this.$store.state.uf,
          };

          if (municipioEixo) {
            const eixoExiste = municipioEixo.findIndex(
              (item) => item.eixoId == eixo.eixoId
            );

            if (eixoExiste > -1) {
              this.allMunicipioEixo[municipio.municipioId][eixoExiste] = {
                ...this.allMunicipioEixo[municipio.municipioId][eixoExiste],
                ...eixo,
              };

              this.$forceUpdate();
            } else {
              this.allMunicipioEixo[municipio.municipioId] = [
                ...this.allMunicipioEixo[municipio.municipioId],
                eixo,
              ];

              this.$forceUpdate();
            }
          } else {
            if (this.allMunicipioEixo[municipio.municipioId]) {
              this.allMunicipioEixo[municipio.municipioId] = [
                ...this.allMunicipioEixo[municipio.municipioId],
                eixo,
              ];
            } else {
              this.allMunicipioEixo[municipio.municipioId] = [eixo];
            }

            this.$forceUpdate();
          }

          this.allMunicipioEixo[municipio.municipioId] = this.allMunicipioEixo[
            municipio.municipioId
          ].sort((a, b) => compare(a, b, "nomeEixo"));
        }
      }
    },
    load() {
      this.setLoading(true);

      this.municipioEixo = { eixo: [], municipio: [] };

      municipioEixoApi
        .listar()
        .then((item) => {
          this.allMunicipioEixo = item.data.sort((a, b) =>
            compare(a, b, "nomeEixo")
          );

          this.allMunicipioEixo = this.allMunicipioEixo.reduce(function (
            rv,
            x
          ) {
            (rv[x["municipioId"]] = rv[x["municipioId"]] || []).push(x);
            return rv;
          },
          {});

          this.longestEixoMunicipio = this.getLongestArray();

          this.setLoading(false);
        })
        .catch((err) => {
          this.setLoading(false);

          this.$notification.error("Erro ao listar eixos nos municipios");
        });
    },
    async save() {
      try {
        this.setLoading(true);
        const a = this.municipioEixo.municipio.map(
          (item) => this.allMunicipioEixo[item.municipioId]
        );

        let b = [];

        a.forEach((item) => {
          b = [...b, ...item];
        });

        await municipioEixoApi.atualizarEmLote(b);
        this.$notification.success("Municípios atualizados com sucesso!");

        this.load();
      } catch (error) {
        this.setLoading(false);

        this.$notification.error("Erro ao salvar");
        console.log("🚀 ~ save ~ error:", error);
      }
    },
    getLongestArray() {
      var longest = 0;
      var longestOrcs = [];
      Object.values(this.allMunicipioEixo).forEach(function (orc) {
        if (orc.length > longest) {
          longestOrcs = [orc];
          longest = orc.length;
        } else if (orc.length == longest) {
          longestOrcs.push(orc);
        }
      });

      return longestOrcs[0].length;
    },
  },
  mounted() {
    this.load();
  },
};
</script>
<style>
.municipioEixoTable td {
  white-space: nowrap;
  padding: 15px 10px !important;
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

.municipioEixoTable td:not(:last-of-type) {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
</style>
